module.exports = __webpack_public_path__ + "img/8.6adf4911.png";